import { Box, Center, Spinner, Text } from "@chakra-ui/react";
import { useTranslation } from "react-i18next";
import { useGetBidV2ForBuyerQuery, type EvalBidDto } from "../../../../autogen/bff-api";
import { AwardCriteriaTab } from "../bid-detail/AwardCriteriaTab";
import { EvaluationFocusStats } from "./EvaluationFocusStats";

interface Props {
  eventId: string;
  bid: EvalBidDto;
}

export const EvaluationFocusBody = ({ eventId, bid }: Props) => {
  const { t } = useTranslation();
  const { data: detail, isLoading } = useGetBidV2ForBuyerQuery({ eventId, bidId: bid.bidId });

  if (isLoading) {
    return (
      <Center py="20">
        <Spinner color="smPrimary" />
      </Center>
    );
  }

  if (!detail) {
    return (
      <Center py="20">
        <Text color="smError">{t("Could not load the bid.")}</Text>
      </Center>
    );
  }

  return (
    <Box maxW="5xl">
      <AwardCriteriaTab detail={detail} headerStats={<EvaluationFocusStats bid={bid} />} />
    </Box>
  );
};
